import { Entity, Column, PrimaryGeneratedColumn, ManyToOne } from "typeorm";
import { CityEntity } from "./city.entity";

@Entity()
export class StreetEntity {

    @PrimaryGeneratedColumn()
    streetId: number;

    @Column()
    name: string;

    @ManyToOne(() => CityEntity, city => city.cityId)
    city: CityEntity


}